import type { NextPageWithAddons } from 'next';

import { NextSeo } from 'next-seo';

import { ContractsSummary } from '@paid-ui/blocks/dashboard/contracts-summary';
import { ProjectCards } from '@paid-ui/blocks/dashboard/project-cards';
import { BasicLayout } from '@paid-ui/layouts/basic';
import { PageTabContainer } from '@paid-ui/layouts/page-tab-container';

const DashboardPage: NextPageWithAddons = () => {
  return (
    <>
      <NextSeo title="Dashboard" />
      <div className="h-screen overflow-y-auto bg-grey-lightest">
        <PageTabContainer size="lg" loadingText="Loading projects...">
          <div className="space-y-9">
            <ContractsSummary />
            <ProjectCards />
          </div>
        </PageTabContainer>
      </div>
    </>
  );
};

DashboardPage.auth = true;
DashboardPage.layout = (page) => <BasicLayout>{page}</BasicLayout>;

export default DashboardPage;
